import React, { useEffect, useState } from 'react';
import { fetchAllSupplier } from 'services';
import { showError, sortArray } from 'utils';
import _ from 'lodash';

const SupplierDropdown = props => {
  const [suppliers, setSuppliers] = useState<Record<string, any>[]>([]);
  const [suppliersForDropDown, setSuppliersForDropDown] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const {
    selectedSupplier,
    setSelectedSupplier,
    setSupplierName,
    setSupplierDetails,
    disabled,
  } = props;

  const fetchSuppliers = async () => {
    try {
      const response = await fetchAllSupplier({
        page: 0,
        limit: 1000,
      });
      const suppliers = response.items.map(row => {
        return {
          id: row.objectId,
          name: row.name,
        };
      });
      setSuppliers(response.items);
      setSuppliersForDropDown(suppliers);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const handleSelect = (supplierId: string) => {
    setSelectedSupplier(supplierId, _.find(suppliers, ['objectId', supplierId]) );
    setSupplierDetails && setSupplierDetails(_.find(suppliers, ['objectId', supplierId]));
  };
  
  const getSupplierOptions = () => sortArray(suppliersForDropDown, 'name').map((supplier, i) => (
    <option key={i} value={supplier.id}>{supplier.name}</option>),
  );
  
  return (
    <select
      value={selectedSupplier}
      disabled={loading || disabled}
      className='form-control'
      onChange={e => handleSelect(e.target.value)}
    >
      <option value='none' hidden={!!selectedSupplier}>Choose Supplier</option>
      {suppliers.length && getSupplierOptions()}
    </select>
  );
};

export default SupplierDropdown;
